module.exports = __webpack_public_path__ + "static/media/mining.32c02a34.jpg";